import { useRegisterSW } from 'virtual:pwa-register/react'
import styles from './ReloadPrompt.module.css'

export function ReloadPrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW()

  if (!needRefresh) return null

  return (
    <div className={styles.banner} role="alert">
      <span className={styles.message}>A new version is available</span>
      <div className={styles.actions}>
        <button
          className={styles.updateButton}
          onClick={() => updateServiceWorker(true)}
        >
          Update
        </button>
        <button
          className={styles.dismissButton}
          onClick={() => setNeedRefresh(false)}
        >
          Dismiss
        </button>
      </div>
    </div>
  )
}
